module.exports = __webpack_public_path__ + "static/media/Lazio.4a40ac22.png";